import { useState, useCallback } from 'react';
import { documentApi } from '../services/documentApi';

export function useDocument() {
  const [document, setDocument] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [saveStatus, setSaveStatus] = useState('saved'); // 'saved' | 'saving' | 'unsaved' | 'error'

  const load = useCallback(async (id) => {
    setLoading(true);
    setError(null);
    try {
      const res = await documentApi.get(id);
      setDocument(res.data);
      setSaveStatus('saved');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const create = useCallback(async (doc = {}) => {
    setLoading(true);
    try {
      const res = await documentApi.create({
        title: doc.title || 'Untitled',
        content: doc.content || '',
        tags: doc.tags || [],
      });
      setDocument(res.data);
      setSaveStatus('saved');
      return res.data;
    } catch (err) {
      setError(err.message);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const save = useCallback(async (updates) => {
    if (!document?.id) return null;
    setSaveStatus('saving');
    try {
      const res = await documentApi.update(document.id, updates);
      setDocument(res.data);
      setSaveStatus('saved');
      return res.data;
    } catch (err) {
      setSaveStatus('error');
      setError(err.message);
      return null;
    }
  }, [document]);

  const remove = useCallback(async (id) => {
    try {
      await documentApi.delete(id || document?.id);
      setDocument(null);
    } catch (err) {
      setError(err.message);
    }
  }, [document]);

  return { document, setDocument, loading, error, saveStatus, setSaveStatus, load, create, save, remove };
}
